import { c as _c } from "react/compiler-runtime";
import NumberFlow from '@number-flow/react';
import clsx from 'clsx';
import { Fragment, useDeferredValue } from 'react';
import { AnimatedCircularProgressBar } from '@/components/magicui/animated-circular-progress-bar';
export function VocabStatics(t0) {
  const $ = _c(42);
  const {
    total,
    text: t1,
    remaining,
    completed,
    progress: t2
  } = t0;
  const text = t1 === undefined ? "" : t1;
  const progress = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== completed || $[1] !== total) {
    t3 = total === 0 ? 0 : (100 * (completed / total)).toFixed(1);
    $[0] = completed;
    $[1] = total;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const percentage = Number(t3);
  const deferredRemaining = useDeferredValue(remaining) || 0;
  const deferredCompleted = useDeferredValue(completed) || 0;
  let t4;
  if ($[3] !== total) {
    t4 = <NumberFlow value={total} locales="en-US" animated={true} isolate={true} />;
    $[3] = total;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== text) {
    t5 = <span>{text}</span>;
    $[5] = text;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <span>{t4}{t5}</span>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = remaining > 0 ? "" : "hidden";
  let t8;
  if ($[10] !== t7) {
    t8 = clsx("flex items-center gap-2.5", t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-neutral-400">, </span>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = true ? deferredRemaining : remaining;
  let t11;
  if ($[13] !== t10) {
    t11 = <span><NumberFlow value={t10} locales="en-US" animated={true} isolate={true} /></span>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <svg className="icon-[lucide--circle] size-3.5 text-neutral-400" />;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11) {
    t13 = <div className="flex items-center gap-1">{t11}{t12}</div>;
    $[16] = t11;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13 || $[19] !== t8) {
    t14 = <Fragment><div className={t8}>{t9}{t13}</div></Fragment>;
    $[18] = t13;
    $[19] = t8;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = completed > 0 ? "" : "hidden";
  let t16;
  if ($[21] !== t15) {
    t16 = clsx("flex items-center gap-2.5", t15);
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-neutral-400">, </span>;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  const t18 = true ? deferredCompleted : completed;
  let t19;
  if ($[24] !== t18) {
    t19 = <span><NumberFlow value={t18} locales="en-US" animated={true} isolate={true} /></span>;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <svg className="icon-[lucide--check-circle] size-3.5 text-neutral-400" />;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t19) {
    t21 = <div className="flex items-center gap-1">{t19}{t20}</div>;
    $[27] = t19;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t16 || $[30] !== t21) {
    t22 = <Fragment><div className={t16}>{t17}{t21}</div></Fragment>;
    $[29] = t16;
    $[30] = t21;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== percentage || $[33] !== progress) {
    t23 = progress ? <div className="flex items-center gap-0.5 pl-1"><span className="text-neutral-300 dark:text-neutral-600">(</span><div className="flex items-center"><NumberFlow value={percentage} locales="en-US" animated={true} isolate={true} />%</div><div className="flex justify-center *:[--CircularProgress-size:16px]!"><AnimatedCircularProgressBar value={percentage} className="text-md size-3 [--stroke-primary:var(--muted-foreground)] [--stroke-secondary:var(--border)] *:data-current-value:hidden" /></div><span className="text-neutral-300 dark:text-neutral-600">)</span></div> : null;
    $[32] = percentage;
    $[33] = progress;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t14 || $[36] !== t22 || $[37] !== t23) {
    t24 = <div className="flex items-center gap-0.5">{t14}{t22}{t23}</div>;
    $[35] = t14;
    $[36] = t22;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t24 || $[40] !== t6) {
    t25 = <div className="flex h-7 items-center text-xs tracking-[.05em] text-neutral-600 tabular-nums dark:text-neutral-400">{t6}{t24}</div>;
    $[39] = t24;
    $[40] = t6;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  return t25;
}